import { createFlowNode, NODE_HANDLE_IDS, NODE_TYPES } from '@flow/nodes';

class _OutputAggregationHelpers {
  generateNode = (data, i) => {
    const node = createFlowNode(NODE_TYPES.OutputAggregationNode);
    node.data = { ...node.data, ...data };
    node.position = this.generateNodePosition(i);
    return node;
  };

  generateNodePosition = (i) => {
    const initialVerticalSeparation = 1320;
    const initialHorizontalSeparation = 1100;
    const horizontalNodeSpacing = 560;
    return { x: initialHorizontalSeparation + horizontalNodeSpacing * i, y: initialVerticalSeparation };
  };

  generateEdges = (nodes, startNodeId) => {
    if (nodes.length === 0) return [];

    function buildEdge(sourceId, targetId) {
      return {
        id: `xy-${sourceId}${NODE_HANDLE_IDS.outputAggregation}${targetId}${NODE_HANDLE_IDS.outputAggregation}-autogen`,
        type: 'custom',
        source: sourceId,
        sourceHandle: NODE_HANDLE_IDS.outputAggregation,
        target: targetId,
        targetHandle: NODE_HANDLE_IDS.outputAggregation,
      };
    }

    const edges = [];
    const firstEdge = buildEdge(startNodeId, nodes[0].id);
    edges.push(firstEdge);
    nodes.forEach((node, i) => {
      const nextNodeId = nodes[i + 1]?.id;
      if (nextNodeId) {
        edges.push(buildEdge(node.id, nextNodeId));
      }
    });
    return edges;
  };
}

export const OutputAggregationHelpers = new _OutputAggregationHelpers();
